/* #region(collapsed) DEVELOPER DOCUMENTATION ════════════════════════════════════ */
/**
  @license
  # COPYRIGHT NOTICE
    © CROUIN 2021. All rights reserved. Powered by MaxDesign.
    ⚠ FR : CONTENU PROTÉGÉ PAR LES DROITS D'AUTEURS (article L. 111-1 du code de la propriété intellectuelle). Cette ressource ne peut pas être utilisée, diffusée ou exploitée sans l'approbation de ses auteurs. Pour plus d'informations, veuillez contacter admin(at)maxdesign.expert
    ⚠ EN : CONTENT PROTECTED WITH AUTHOR COPYRIGHTS (section L. 111-1 of the intellectual property code). This resource may not be used, distributed or exploited without the approval of its authors. For any information request, please contact admin(at)maxdesign.expert
 
  # INTRODUCTION
    Each bundle uses HTML custom element <bundle-maxdesign>.
    Custom elements extend HTML by creating new elements that carry their own JavaScript for adding new behavior.
 
  # POPULAR JAVASCRIPT METHODS
    // get bundle data
    document.querySelector('bundles-maxdesign').addEventListener('bundle:change', e => {
      const bundle = e.detail;
      const data = {
        currentVariant: bundle.variant,
        price: bundle.price,
        comparePrice: bundle.comparePrice,
        savings: bundle.savings,
        image: bundle.image,
        inventory: bundle.getInventory(),
        ...
      }
    });
 
  # MORE INFORMATION
    - Contact us at admin(at)maxdesign.expert
*/
/* #endregion ════════════════════════════════════════════════════════════════════ */

window.MaxDesign = window.MaxDesign || class {};
MaxDesign.bundles = { get: () => document.querySelectorAll('bundles-maxdesign') };

class Bundles extends HTMLElement {
  connectedCallback() {
    this.settings = this.json(this);
    this.activeBundle = this.querySelector('.md-bundle[data-bundle-status="open"]') || this.querySelector('.md-bundle');
    this.atcBtn = this.settings.DOM.atc && document.querySelectorAll(this.settings.DOM.atc);
    this.themeOptions = this.settings.DOM.options && document.querySelector(this.settings.DOM.options);
    this.resetStates();
    this.onFormSubmit();
    this.addEventListener('bundle:change', this.onBundleChange.bind(this));
  }

  /* ════════════════════════════════════════════════════════════════════════ */
  /* #region(collapsed) Reset States */

  /**
   * reset default global prices that may be initially inaccurate
   * overwrite themes that uses javascript to change price on dom ready
   * trigger jquery.ready + setTimeout to make sure our code runs last
   */
  resetStates() {
    document.addEventListener('DOMContentLoaded', () => {
      if (typeof jQuery != 'undefined') jQuery.ready();
      setTimeout(() => {
        this.setPrices();
        this.updateATC(this.activeBundle);
        document.body.setAttribute('loaded', '');
      });
    });
    addEventListener('load', this.setPrices.bind(this));
  }

  setPrices() {
    this.updateDOM(this.mainPrices, this.money(this.activeBundle.price));
    this.updateDOM(
      this.mainComparePrices,
      this.activeBundle.comparePrice > this.activeBundle.price
        ? this.money(this.activeBundle.comparePrice / this.activeBundle.dataset.bundleQuantity)
        : ''
    );
  }
  /* #endregion ═════════════════════════════════════════════════════════════ */

  /* ════════════════════════════════════════════════════════════════════════ */
  /* #region(collapsed) On Form Submit */
  onFormSubmit() {
    document.addEventListener(
      'click',
      event => {
        for (let btn of document.querySelectorAll(this.settings.DOM.atc)) {
          if (btn.contains(event.target)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.activeBundle.submit(); /* until requestSubmit() gets better support */
            break;
          }
        }
      },
      { capture: true }
    );
  }
  /* #endregion ═════════════════════════════════════════════════════════════ */

  /* ════════════════════════════════════════════════════════════════════════ */
  /* #region(collapsed) On Bundle Change */

  /**
   * Update all Bundle content
   * Main prices shows unit price to stick to standards and for consistency
   * @param {Object} e - event detail (bundle type and bundle object)
   */
  onBundleChange(e) {
    const { bundle, type } = e.detail;
    if (type == 'variant' || type == 'plan') {
      this.updateDOM(bundle.DOM.price, this.money(bundle.price));
      this.updateDOM(bundle.DOM.comparePrice, this.money(bundle.comparePrice));
      this.updateDOM(bundle.DOM.unitPrice, this.money(bundle.unitPrice));
      this.updateDOM(bundle.DOM.savings, bundle.savings);
      this.updateDOM(bundle.DOM.savingsDiff, this.money(bundle.savingsDiff));
      this.updateDOM(bundle.DOM.inventory, bundle.getInventory());
    }
    this.updateThemeVariants(bundle);
    this.updateATC(bundle);
    this.updateThemePrices(bundle);
    setTimeout(() => {
      this.updateThemePrices(bundle);
    });
  }
  /* #endregion ═════════════════════════════════════════════════════════════ */

  /* ════════════════════════════════════════════════════════════════════════ */
  /* #region(collapsed) Helpers & Utilities */

  /**
   * update DOM text content
   * @param {Object} el - element or array of elements.
   * @param {String} value - updated string value.
   */
  updateDOM(el, value) {
    if (el != null && typeof el[Symbol.iterator] === 'function') {
      for (let node of el) node.textContent = value;
    } else if (el) {
      el.textContent = value;
    } else return false;
  }

  /**
   * Enable / disable ATCs
   * @param {Object} bundle - bundle Object
   */
  updateATC(bundle) {
    if (!this.atcBtn) return;
    for (let btn of this.atcBtn) {
      if (bundle.variant.available) {
        btn.disabled = false;
        btn.textContent = this.settings.bundles_atc_text.replace('[price]', this.money(this.activeBundle.price));
      } else {
        btn.disabled = true;
        btn.textContent = this.settings.product_unavailable;
      }
    }
  }

  /**
   * Allows to preserve the native theme interactions
   * on variant change events
   * @param {Object} - bundle target
   */
  updateThemeVariants(bundle) {
    const optionsFields = this.themeOptionsFields;
    if (!optionsFields) return;
    const variant = bundle.variant;
    variant.options.forEach(option => {
      const bundleOption = option.toLowerCase();
      const match = optionsFields.find(field => {
        return field.nodeName == 'SELECT'
          ? [...field.options].some(
              option => option.value.toLowerCase() == bundleOption && (field.value = option.value)
            )
          : field.value.toLowerCase() == bundleOption && (field.checked = true);
      });
      match?.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /**
   * Update theme prices in DOM
   * @param {Object} - bundle target
   */
  updateThemePrices(bundle) {
    const quantity = +bundle.dataset.bundleQuantity;
    this.updateDOM(this.mainPrices, this.money(bundle.price / quantity));
    this.updateDOM(
      this.mainComparePrices,
      bundle.comparePrice > bundle.price ? this.money(bundle.comparePrice / quantity) : ''
    );
  }

  /**
   * Money formater
   * @param {String} money value.
   * @return {String} converted money value.
   */
  money(cents) {
    const { moneyFormat } = this.settings;
    const regex = /\{\{\s*(\w+)\s*\}\}/;
    const placeholder = moneyFormat.match(regex)[1];
    const [precision, thousands, decimal] = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
    }[placeholder];
    const formatWithDelimiters = number => {
      if (isNaN(number) || number === null) return 0;
      const fixedNumber = (number / 100.0).toFixed(precision);
      const [dollars, cents] = fixedNumber.split('.');
      const thousandsRegex = /(\d)(?=(\d{3})+$)/g;
      return dollars.replace(thousandsRegex, `$1${thousands}`) + (cents ? decimal + cents : '');
    };
    const value = formatWithDelimiters(typeof cents === 'string' ? cents.replace('.', '') : cents);
    return moneyFormat.replace(regex, value);
  }
  /* #endregion ═════════════════════════════════════════════════════════════ */

  /* ════════════════════════════════════════════════════════════════════════ */
  /* #region(collapsed) Getters & Setters */

  /**
   * @returns {Object} custom element settings
   */
  get json() {
    return scope => JSON.parse(scope.querySelector(':scope > [type="application/json"]')?.innerText || '{}');
  }

  get mainPrices() {
    return this.settings.DOM.price && document.querySelectorAll(this.settings.DOM.price);
  }

  get mainComparePrices() {
    return this.settings.DOM.originalPrice && document.querySelectorAll(this.settings.DOM.originalPrice);
  }

  get themeOptionsFields() {
    return (this._themeOptionsFields =
      this._themeOptionsFields ||
      (this.themeOptions && [
        ...this.themeOptions.querySelectorAll('input:not([type="hidden"]):not([name*="id"]), select:not([name*="id"])'),
      ]));
  }
  /* #endregion ═════════════════════════════════════════════════════════════ */
}

class Bundle extends HTMLElement {
  connectedCallback() {
    this.master = this.closest('.md-bundles');
    this.settings = this.master.settings;
    this.data = this.master.json(this);
    this.inputs = this.querySelectorAll('input[name$="[id]"]');
    this.variant = this.data.product.variants.find(variant => variant.id == this.inputs[0].value);
    this.index = +this.dataset.bundleIndex;
    this.quantity = +this.dataset.bundleQuantity;
    this.planGroupIds = this.dataset.bundlePlanGroupIds;
    this.discount = { type: this.dataset.bundleDiscountType, value: +this.dataset.bundleDiscountValue };
    this.setVariables();
    this.onInit();
    this.onBundleChange();
    this.onVariantChange();
    this.onSellingPlanChange();
    this.onPropertyChange();
  }

  /* ════════════════════════════════════════════════════════════════════════ */
  /* #region(collapsed) On Init */

  /**
   * Update some variables and elements before user interaction
   * Reset global prices and btn status on init
   * Fix height animation on init for first bundle
   */
  onInit() {
    this.resetDropdowns();
    this.setInventory();
    this.setPrices();
    this.setImage();
    this.toggleAttribute('disabled', this.disabled);
  }
  /* #endregion ═════════════════════════════════════════════════════════════ */

  /* ════════════════════════════════════════════════════════════════════════ */
  /* #region(collapsed) On User Interaction */

  /**
   * toggle classes & attributes on bundle change.
   */
  onBundleChange() {
    this.addEventListener('click', () => {
      this.status != 'open' &&
        this.DOM.bundles.forEach(bundle => {
          if (bundle == this) {
            this.master.activeBundle = this;
            this.status = 'open';
            this.event = 'bundle';
          } else bundle.status = 'close';
        });
    });
  }

  /**
   * Update pack dataset on variant change.
   */
  onVariantChange() {
    if (this.dataset.bundleVariants === 'true') {
      for (const option of this.DOM.options) {
        option.addEventListener('change', () => {
          this.variant = this.findVariant(option, this.data.product.variants);
          if (!this.variant) return;
          this.toggleAttribute('disabled', this.disabled);
          const setIndex = +option.dataset.variantSet - 1;
          this.inputs[setIndex].value = this.variant.id;
          this.setPrices();
          this.setImage();
          this.event = 'variant';
        });
      }
    }
  }

  /**
   * Update pack dataset on selling plan change.
   */
  onSellingPlanChange() {
    for (const plan of this.DOM.plans) {
      plan.addEventListener('change', e => {
        this.setPrices();
        this.event = 'variant';
      });
    }
  }

  /**
   * Update image & gallery on property change
   * Properties options must replicate original variant options
   */
  onPropertyChange() {
    if (!this.settings.defaultVariantSet) return;
    for (const property of this.DOM.properties) {
      property.addEventListener('change', () => {
        const variant = this.findVariant(property, this.settings.defaultVariantSet);
        if (!variant) return;
        this.setImage(variant);
        this.event = 'property';
      });
    }
  }
  /* #endregion ═════════════════════════════════════════════════════════════ */

  /* ════════════════════════════════════════════════════════════════════════ */
  /* #region(collapsed) Utility & Helper Methods */

  /**
   * Action as bundle form is submitted
   */
  async submit() {
    const cartController = MaxDesign?.cart?.controller;
    if (cartController) this.master.atcBtn?.forEach(btn => (cartController.loading = { el: btn, load: true }));
    try {
      const formData = new FormData(this.DOM.form);
      const response = await fetch(Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData });
      const items = await response.json();
      if (response.status >= 300) throw items;
      await this.handleATCAction(this.settings);
    } catch (error) {
      alert(`${error.description || error}`);
      console.error(error);
      try {
        await this.handleATCAction(this.settings);
      } catch (innerError) {
        console.warn('Fallback ATC handler failed:', innerError);
      }
    } finally {
      if (cartController) this.master.atcBtn?.forEach(btn => (cartController.loading = { el: btn, load: false }));
    }
  }

  async handleATCAction(settings) {
    switch (settings.atc_action) {
      case 'cart':
      case 'checkout':
        location.href = `${Shopify.routes.root}${settings.atc_action}`;
        return 'redirected';

      case 'cart-maxdesign':
        if (MaxDesign?.cart?.controller) {
          const modal = MaxDesign.modal.cart;
          const cartController = MaxDesign.cart.controller;
          modal.overlay = { state: 'loading' };
          await cartController.render(await cartController.fetch());
          modal.open();
          return 'modal';
        } else throw `Cart by MaxDesign disabled. Change "ATC action" (Bundles section's settings)`;
      default:
        try {
          new Function(settings.atc_action_custom)();
          return 'custom';
        } catch (error) {
          alert(
            `Fix broken code in "Custom ATC Action" (Bundles theme settings), or change "ATC action" (Bundles section's settings)`
          );
          return 'error';
        }
    }
  }

  /**
   * update inventory of specific variant
   */
  getInventory() {
    if (this.settings.stocks_type == 'time' && this.variant.inventoryMeta.length) {
      this.invMin = parseInt(+this.variant.inventoryMeta.split('-')[0]) || 0;
      this.invMax = this.decrementInventory(this.invMin, parseInt(+this.variant.inventoryMeta.split('-')[1]) || 0);
    } else {
      this.invMin = 0;
      this.invMax = Math.max(+this.variant.inventory, 0);
    }
    return Math.max(this.invMin, this.invMax);
  }

  /**
   * decrement inventory based on time of the day + min/max inventory
   * offset is allowed to reset inventory after specific time
   * @param {Number} invMin - min inventory
   * @param {Number} invMax - inventory to decrement
   * @return {Number} inventory after decrementation
   */
  decrementInventory(invMin, invMax) {
    let date = new Date();
    let timeToday = (date.getTime() - date.setHours(this.settings.virtual_stocks_start, 0, 0, 0)) / 1000 / 60 / 60 / 24;
    let decrementRatio = (timeToday < 0 ? Math.abs(timeToday) : 1 - timeToday) + invMin / invMax;
    return Math.round(invMax * Math.min(decrementRatio, 1));
  }

  /**
   * Reset dropdowns value on load
   */
  resetDropdowns() {
    document.addEventListener('pageshow', () => this.DOM.options.forEach(sel => (sel.selectedIndex = 0)));
  }

  /**
   * @param {Object} selector - Changed selector
   * @param {Object} variants - Variant list of current bundle (or default variants)
   * @return {Object} selected variant
   */
  findVariant(selector, variants) {
    const selectors = selector.hasAttribute('data-variant-set')
      ? this.querySelectorAll(`[data-variant-set="${selector.dataset.variantSet}"]`)
      : selector.hasAttribute('data-property-set')
      ? this.querySelectorAll(`[data-property-set="${selector.dataset.propertySet}"]`)
      : this.DOM.options;
    const options = [...selectors].map(option => option.value);
    return variants.find(variant => options.every((value, index) => value === variant.options[index]));
  }
  /* #endregion ═════════════════════════════════════════════════════════════ */

  /* ════════════════════════════════════════════════════════════════════════ */
  /* #region(collapsed) Instantiate Variables */

  setVariables() {
    this.DOM = {
      bundles: [...this.parentElement.children],
      price: this.querySelector('span[data-variant-price]'),
      comparePrice: this.querySelector('span[data-variant-compare-price]'),
      unitPrice: this.querySelector('.md-bundle__unit-price'),
      savings: this.querySelector('.md-bundle__savings'),
      savingsDiff: this.querySelector('.md-bundle__savings--diff'),
      inventory: this.querySelector('.md-bundle__inventory'),
      image: this.querySelector('.md-bundle__image > span'),
      form: this.querySelector('.md-bundle__form'),
      items: this.querySelectorAll('.md-bundle__items'),
      options: this.querySelectorAll('.md-bundle__items select'),
      plans: this.querySelectorAll('.md-bundle__plans input'),
      properties: this.querySelectorAll('.md-bundle__properties select'),
    };
  }

  /**
   * Append inventory, inventory policy & meta inventory values to each variant
   * Update meta stocks on init
   */
  setInventory() {
    for (let [index, variant] of this.data.product.variants.entries()) {
      variant.inventory = this.data.inventory[index];
      variant.inventoryMeta = this.data.inventoryMeta[index];
    }
    if (this.settings.stocks_type != 'shopify' && this.DOM.inventory)
      this.master.updateDOM(this.DOM.inventory, this.getInventory());
  }

  /**
   * change image (variant or product featured image)
   */
  setImage(variant = this.variant) {
    const img = variant.featured_image ? variant.featured_image.src : this.data.product.featured_image;
    this.DOM.image.style.backgroundImage = `url("${img}&width=90")`;
  }

  /**
   * Set all prices
   */
  setPrices() {
    if (!this.settings.bundleType.includes('quantities')) {
      const plan = this.sellingPlan;
      const price = plan?.price || this.variant.price;
      const originalPrice = plan?.compare_at_price || this.variant.compare_at_price;
      const priceDiff = originalPrice - price;
      const showCP = this.variant.available && originalPrice && this.data.showCP;
      this.price = this.variant.available ? price : this.settings.product_unavailable;
      this.comparePrice = showCP ? originalPrice : price;
      this.unitPrice = price;
      this.savings = Math.round((priceDiff * 100) / originalPrice);
      this.savingsDiff = Math.round(priceDiff);
    } else this.setPricesByQty();
  }

  /**
   * Set all prices based on quantity and discounts
   * @param {Object} option - changed selector
   */
  setPricesByQty() {
    // get total bundle price
    const bundleData = [...this.DOM.items].reduce((obj, _, index) => {
      const variant = this.data.product.variants.find(variant => variant.id == this.inputs[index].value);
      obj.price = (obj.price || 0) + variant.price;
      obj.comparePrice = (obj.comparePrice || 0) + variant.compare_at_price;
      return obj;
    }, {});
    // update data prices
    const showCP = this.variant.available && this.variant.compare_at_price && this.data.showCP;
    const discountValue = isNaN(this.discount.value) ? 0 : this.discount.value;
    const discountAmount =
      this.discount.type == 'percentage' ? (bundleData.price * discountValue) / 100 : discountValue;
    const discountedPrice = bundleData.price - discountAmount;
    const originalPrice = bundleData.comparePrice || bundleData.price;
    this.price = this.variant.available ? discountedPrice : this.settings.product_unavailable;
    this.comparePrice = showCP ? bundleData.comparePrice : bundleData.price;
    this.unitPrice = discountedPrice / this.quantity;
    this.savings = Math.round(((originalPrice - discountedPrice) * 100) / originalPrice);
    this.savingsDiff = bundleData.comparePrice - bundleData.price + discountAmount;
  }
  /* #endregion ═════════════════════════════════════════════════════════════ */

  /* ════════════════════════════════════════════════════════════════════════ */
  /* #region(collapsed) Getters & Setters */

  /**
   * {String} type - variant or bundle type
   */
  set event(type) {
    const detail = { bundle: this, type };
    this.master.dispatchEvent(new CustomEvent('bundle:change', { detail }));
  }

  /**
   * Set status of bundle
   * @param {string} status - accept 'close' or 'open'
   */
  set status(status) {
    this.dataset.bundleStatus = status;
  }

  /**
   * Get status of bundle
   * @return {String} - 'close' or 'open'
   */
  get status() {
    return this.dataset.bundleStatus;
  }

  /**
   * Get active plan based on current variant
   */
  get sellingPlan() {
    const activePlanId = this.querySelector('input[name$="selling_plan"]:checked')?.value;
    return this.variant.selling_plan_allocations
      .filter(plan => this.planGroupIds.includes(plan.selling_plan_group_id))
      ?.find(plan => plan.selling_plan_id == activePlanId);
  }

  /**
   * Whether we should disable the current bundle based on variant quantity available
   */
  get disabled() {
    return this.variant.inventory < this.quantity && this.variant.inventory_management != null;
  }

  /* #endregion ═════════════════════════════════════════════════════════════ */
}
customElements.define('bundles-maxdesign', Bundles);
customElements.define('bundle-maxdesign', Bundle);
